var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"page_searcher"},[_c('Searcher',{ref:"searcher",attrs:{"items":_vm.config.searchers,"download":true},on:{"search":_vm.getData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }